<template>
  <div class="NewUserCoupon" v-if="CouponInfo && CouponInfo.CountDownTime > 0 && isHasUserCoupon && isLogin"  >
    <CgModalMiddle
      v-show="status == 1"
      :is-show-close="false">
      <div
        slot="modal_content"
        class="modal-content _pointer" @click="clickModal">
        <div class="dialog-btn" v-if="CouponInfo.CountDownTime > 43200000" />
        <div class="count-down" v-else>
          <CountDown
            v-show="CouponInfo.CountDownTime"
            :remain-time="(CouponInfo.CountDownTime/1000)"/>
        </div>


        <div class="price">
          <span class="txt-price">{{ CouponInfo.discount_amount | disposePrice }}</span>
          <span class="txt-yuan">元</span>
        </div>
        <i
          class="iconfont icon-cha"
          @click.stop="closeModal"/>
      </div>
    </CgModalMiddle>

    <div
      v-show="status == 2"
      class="buoy-box _pointer"
      @click="clickModal"
    >

      <div class="dialog-btn" v-if="CouponInfo.CountDownTime > 43200000" />
      <div class="count-down" v-else>
        <CountDown
          v-if="CouponInfo.CountDownTime"
          :remain-time="(CouponInfo.CountDownTime/1000)"/>
      </div>
      <div class="price">
        <span class="txt-price">{{ CouponInfo.discount_amount | disposePrice }}</span>
        <span class="txt-yuan">元</span>
      </div>
      <i
        class="iconfont icon-cha"
        @click.stop="status = -1"/>
    </div>
  </div>
</template>

<script>
// import CountDown from '@/components/act/new-user-coupon/count-down'
import CountDown from '@/components/act/new-user-coupon/count-down-v2'
import {mapState} from "vuex";
import {fnGuideDownloadCount} from "@/fn";
import {HOME} from "@/constant/HOME";
import {LOGIN_GUIDE_STATE} from "@/constant/LOGIN_GUIDE";

export default {
  name: "NewUserCoupon",
  props: {
    /* 新人红包信息 */
    newUserCouponInfo: {
      type: Object,
      default: function () {
        return {
          end_time: ''
        };
      },
    },
    newUserCouponState: {
      type: String | Number,
      default: -1
    }, // -1都不显示 1显示大弹框 2显示右上角浮标
  },
  computed: {
    ...mapState('user',
      ['isHasUserCoupon', 'isLogin']
    ),
    isLogin() {
      return this.$store.state.user.isLogin
    }
  },
  watch: {
    newUserCouponInfo: {
      handler(n, o) {
        if (n) {
          this.CouponInfo = n;
          if( (n.coupon_id == 4 && this.status == 1) || n.coupon_id == 5 && this.status == 1){
            fnGuideDownloadCount.trackNewUser(HOME.NEW_USER_COUPON_TYPE.COUPON,HOME.NEW_USER_COUPON_TYPE.POSITION.CURRENT_PAGE)
          }
        }
      },
      deep: true,
      immediate: true
    },
    /*newUserCouponState: {
      handler(n, o) {
        if (n) {
          this.status = n;
          console.log(this.newUserCouponInfo)
          this.CouponInfo = this.newUserCouponInfo;
        }
      },
      immediate: true
    }*/
  },
  components: {
    CountDown
  },
  mounted() {
    let  isNewUserCoupon = this.$localStorage.getItem('isNewUserCoupon');
    console.log(!isNewUserCoupon)
    if (!isNewUserCoupon){
      console.log('暂无存储')
      this.status = 1
    }else{
      console.log('有存储')
      this.status = isNewUserCoupon

    }
  },
  data() {
    return {
      time: '1659433559',
      status: 1,
      CouponInfo: {}
    }
  },
  methods: {
    closeModal() {
      this.$localStorage.setItem('isNewUserCoupon', 2);
      this.status = 2;
    },

    clickModal(){
      this.closeModal();
      this.$emit('clickModal')
    }
  },
  filters:{
    disposePrice(val) {
      return parseFloat(val).toFixed(0);
    },
  }
}

</script>

<style lang="scss" scoped>
.NewUserCoupon {

  .modal-content {
    @include BgImage(426px, 446px, 'pay/coupon/new-user-coupon/dialog.png');
    position: relative;

    .count-down {
      //@include Position(1, 4, 153px, 36px);
      @include Position(1,3,81px,77px);



      /deep/ .CountDown {
       /* width: 183px;
        line-height: 48px;
        background: #EE1008;
        //box-shadow: 0px 5px 8px 0px rgba(195, 11, 5, 0.43);
        border-radius: 10px;
        text-align: center;
        font-size: 40px;
        color: #FFFFFF;
        font-weight: bold;*/
      }
    }

    .dialog-btn{
      @include BgImage(155px, 42px, 'pay/coupon/new-user-coupon/dialog-btn.png');
      @include Position(1,3,70px,68px);
    }

    .price {
      //@include Position(1, 5, 50%, 60px);
      @include Position(1,4,87px,59px);
      font-size: 0;
      font-weight: bold;
      color: #FFFFFF;

      .txt-price {
        font-size: 68px;
      }

      .txt-yuan {
        font-size: 18px;
        vertical-align: 6px;
        margin-left: 5px;
      }
    }

    .icon-cha {
      display: inline-block;
      width: 38px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      font-size: 17px;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 50%;
      @include Position(1, 2, -27px, 38px);
      cursor: pointer;
      @include ElementHover('', rgba(255, 255, 255, 0.4))


    }
  }

  .buoy-box {
    @include BgImage(180px, 167px, 'pay/coupon/new-user-coupon/buoy.png');
    position: fixed;
    right: 15px;
    top: 200px;
    z-index: 998;

    /deep/ .CountDown {
      /*width: 86px;
      height: 23px;
      background: #EE1008;
      box-shadow: 0px 5px 8px 0px rgba(195, 11, 5, 0.43);
      border-radius: 12px;
      font-size: 14px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 23px;*/
      //@include Position(1, 4, 63px, 14px);
      @include Position(1,3,25px,27px);


      ._user-select{
        display: inline-block;
        width: 32px;
        height: 32px;
        background: #F8FDFF;
        border-radius: 4px;
        font-size: 25px;
        font-weight: bold;
        color: #FD5807;

        width: 17px;
        height: 17px;
        font-size: 13px;

      }
      .icon_colon{
        font-size: 20px;
        font-weight: bold;
        color: #FFDF89;
        margin: 0 3px;
        font-size: 8px;
      }
    }

    .dialog-btn{
      @include BgImage(67px, 18px, 'pay/coupon/new-user-coupon/buoy-btn.png');
      @include Position(1,3,26px,26px);
    }

    .price{
      @include Position(1,4,34px,27px);
      font-size: 0;
      color: #FFFFFF;
      font-weight: bold;

      .txt-price{
        font-size: 28px;
      }
      .txt-yuan{
        font-size: 9px;
        margin-left: 2px;
        vertical-align: 2px;
      }
    }

    .icon-cha {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      @include Position(1, 4, 50%, -29px);
      transform: translateX(-50%);
      font-size: 10px;
      text-align: center;
      line-height: 24px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>
